import { render, staticRenderFns } from "./RequestSentModal.vue?vue&type=template&id=2b942dbb&scoped=true"
import script from "./RequestSentModal.vue?vue&type=script&lang=js"
export * from "./RequestSentModal.vue?vue&type=script&lang=js"
import style0 from "./RequestSentModal.vue?vue&type=style&index=0&id=2b942dbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b942dbb",
  null
  
)

export default component.exports